import * as React from 'react';
import { BookingMethod } from '../timeCentric/view/BookingMethodSection';

const STORAGE_BOOKING_METHOD = 'bookingMethod';

function getSavedBookingMethod(): BookingMethod | null {
    let savedBookingMethod = localStorage.getItem(STORAGE_BOOKING_METHOD) as BookingMethod;

    return savedBookingMethod ? savedBookingMethod : null;
}

export function manageSavedBookingMethod(bookingMethod: BookingMethod) {
    if (bookingMethod === BookingMethod.TimeCentric) {
        localStorage.removeItem(STORAGE_BOOKING_METHOD);
    } else if (bookingMethod === BookingMethod.PhotographerCentric) {
        localStorage.setItem(STORAGE_BOOKING_METHOD, BookingMethod.PhotographerCentric);
    }
}

export function clearPersistedBookingMethod() {
    localStorage.removeItem(STORAGE_BOOKING_METHOD);
}

export function usePersistBookingMethodSelection(
    bookingMethod: BookingMethod,
    changeBookingMethod: (bookingMethod: BookingMethod) => void,
    deps: any[]
) {
    React.useEffect(() => {
        let existingBookingMethod = getSavedBookingMethod();

        if (existingBookingMethod && bookingMethod === BookingMethod.TimeCentric) {
            changeBookingMethod(BookingMethod.PhotographerCentric);
        }
    }, [...deps]);
}
